// link api
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL + '';

// link web
export const BASE_URL = process.env.REACT_APP_BASE_URL;
// link web mvc phân quyền
// export const MVC_URL = 'https://icrm.isdcorp.vn/';
export const MVC_URL = process.env.REACT_APP_MVC_URL;

// mã hóa password và username
export const CRYPTED_KEY = '3fiYLDFb8yNHPqEyUGMe62fJpnyaNXuM';
// số item trên trang (mặc định)
export const PAGE_SIZE_DEFAULT = 10;
//  Tên hệ thống
export const SYSTEM_TITLE = 'iCRM System';


//============================ ZALO OA =======================================
// OA auth url
export const OA_AUTH_URL = 'https://oauth.zaloapp.com/v4/oa/permission';
// OA app id
export const OA_APP_ID = process.env.REACT_APP_OA_APP_ID;
// OA redirect_uri
export const OA_REDIRECT_URI = process.env.REACT_APP_OA_REDIRECT_URI;

export const INTEGRATION_ZALO_API_URL = process.env.REACT_APP_INTEGRATION_ZALO_API_URL;

// Format hiển thị ngày/tháng/năm
export const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
// Format hiển thị ngày và giờ:phút
export const DATE_TIME_FORMAT_DEFAULT = 'DD/MM/YYYY HH:mm';
// Format ngày gửi api
export const DATE_FORMAT_POST = 'YYYY-MM-DD';

export const CONNECT_ZALO = process.env.REACT_APP_CONNECT_ZALO;

export const ICRM_ZALO = process.env.REACT_APP_ICRM_ZALO;

export const VARIABLE_CHECK_ZALO = process.env.REACT_APP_VARIABLE;




// =====================================================================================================================
// Hiện tại đang config bằng biến môi trường (.env) chỉ cần thêm các biến môi trường
// VD: .end.prd
// + và lấy ra sử dụng trong đây, hạn chế của việc này là không thể thay đổi sau khi build
// + vì chỉ định build:prd là build ra bảng producting , nếu muốn thay đổi môi trường thì build bảng khác


// nếu muốn đặt config ra 1 file riêng thì sử dụng đoạn code ở dưới
// đặt tạo file config.json ở thư mục public rồi dùng axios hoặc fetch để lấy config từ file
// có thể đổi config sau khi build


// const configUrl = process.env.PUBLIC_URL + 'config.json';
// let BASE_API_URL;
// async function getApiUrl() {
//     try {
//         const response = await axios.get(`${process.env.PUBLIC_URL}/config.json`);
//         const data = await response.data;
//         //   apiUrl = data.apiUrl;
//         BASE_API_URL = data.apiUrl

//     } catch (error) {
//         // Xử lý lỗi nếu cần
//         console.error('Lỗi khi lấy apiUrl:', error);
//         //   apiUrl = ''; // Giá trị mặc định hoặc xử lý lỗi
//     }
// }
// // Gọi hàm để lấy giá trị apiUrl
// getApiUrl();
// export { BASE_API_URL }

//============================================================================================================================






